import { connect } from 'react-redux';

import { actionCreators } from 'dux/clickTracker';
import { selectors as userSelectors } from 'dux/user';
import { selectors as catalogSelectors } from 'dux/catalog';
import StepOne from './StepOne';

function mapStateToProps(state) {
  return {
    isORv4User: userSelectors.isORv4User(state),
    validRegions: catalogSelectors.regionsByServiceSubtypeSelector(state),
    user: userSelectors.getIdentityState(state),
  };
}

const mapDispatchToProps = {
  trackButtonClick: actionCreators.trackButtonClick,
};

export default connect(mapStateToProps, mapDispatchToProps)(StepOne);
